import React from 'react'
import { Route,Routes } from 'react-router-dom'
import Home from './pages/Home'
import About from './pages/About'
import Deals from './pages/Deals'
import Reservation from './pages/Reservation'
import BookYours from './pages/BookYours'

const App = () => {
  return (
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/about' element={<About/>}/>
      <Route path='/deals' element={<Deals/>}/>
      <Route path='/reservation' element={<Reservation/>}/>
      <Route path='/book-yours' element={<BookYours/>}/>
    </Routes>
  )
}

export default App
